/* Branded 404 — shown for any unknown route. On-brand warm-dark canvas,
   sage accent, the Curated·H·omes wordmark, and a way back home. */
import { Link } from 'react-router-dom'
import './not-found.css'

export function NotFound() {
  return (
    <main className="nf">
      <div className="nf-inner">
        <div className="nf-mark">
          Curated<b>H</b>omes
        </div>
        <div className="nf-code">404</div>
        <h1 className="nf-title">This page has kept its own counsel.</h1>
        <p className="nf-sub">
          The page you’re looking for isn’t here — it may have moved, or never existed.
        </p>
        <Link className="nf-link" to="/">
          ← Return home
        </Link>
      </div>
    </main>
  )
}
